import { cn } from "@omni/utils/styles";
import { useState } from "react";

import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type CreateReviewProps = {
    rating: number;
    range: number;
    writeReview: (initialRating?: number) => void;
};

export const CreateReviewComponent = ({
    rating,
    range,
    writeReview
}: CreateReviewProps) => {
    const { t } = useGranite();

    const [hoveredValue, setHoveredValue] = useState<number>(0);

    const isActive = (index: number) => {
        return !hoveredValue ? index <= rating : index <= hoveredValue;
    };

    const createHandleOnMouseEnter = (index: number) => () => {
        setHoveredValue(index);
    };

    const createHandleOnClick = (index: number) => () => {
        if (rating === index) {
            setHoveredValue(0);
        }

        writeReview(index);
    };

    const handleOnMouseLeave = () => {
        setHoveredValue(0);
    };

    return (
        <section>
            <p className={cn("tw:text-lg tw:mb-0")}>
                {t("product.reviews.summary.createReview.title")}
            </p>
            <div
                className={cn("tw:flex")}
                onMouseLeave={handleOnMouseLeave}
            >
                {[...Array(range)].map((_, index) => (
                    <button
                        type={"button"}
                        key={index}
                        className={cn(
                            "tw:relative tw:h-12 tw:w-12 tw:border-none tw:bg-white",
                            "tw:before:content-[''] tw:before:z-0 tw:before:border tw:before:border-rating tw:before:absolute tw:before:top-1 tw:before:left-1 tw:before:h-[calc(100%-0.5rem)] tw:before:w-[calc(100%-0.5rem)] tw:before:rounded-md tw:before:transition-colors",
                            {
                                "tw:before:bg-rating": isActive(index + 1)
                            }
                        )}
                        onMouseEnter={createHandleOnMouseEnter(index + 1)}
                        onClick={createHandleOnClick(index + 1)}
                    >
                        <svg
                            aria-hidden={"true"}
                            fill={"none"}
                            viewBox={"0 0 34 34"}
                            className={cn(
                                "tw:absolute tw:top-3 tw:left-3 tw:h-[calc(100%-1.5rem)] tw:w-[calc(100%-1.5rem)] tw:flex tw:items-center tw:justify-center"
                            )}
                        >
                            <g
                                fill={"#ffffff"}
                                strokeWidth={"1.5"}
                                className={"tw:stroke-rating tw:fill-white"}
                            >
                                <path
                                    d={
                                        "M16.3076923,1.76513255 L20.8381599,11.4172719 L31.0592597,12.978917 L23.6603835,20.5621906 L25.3975353,31.2117909 L16.3076923,26.1870493 L7.21784935,31.2117909 L8.95500108,20.5621906 L1.55612493,12.978917 L11.7772247,11.4172719 L16.3076923,1.76513255 Z"
                                    }
                                />
                            </g>
                        </svg>
                    </button>
                ))}
            </div>
            <p className={cn("tw:text-sm tw:mt-2")}>
                {t("product.reviews.summary.createReview.emailRequired")}
            </p>
        </section>
    );
};
